<template>
  <div class="config row">
    <div class="col-xs-12 mt-sm-1">
      <div :class="computedClassHeader">Configuração / Rede</div>
      <b-card-group deck :class="computedClass">
        <b-card
          bg-variant="white"
          header-bg-variant="light"
          footer-bg-variant="light"
          align="center"
          header-text-variant="black"
        >
          <header slot="header">
            <h4>{{ cardHeaderTitle }}</h4>
          </header>
          <div class="card-text start-xs">
            <div v-if="!connectionConfigForm">
              <p><strong>REDE:</strong> {{ networkInfo.NETWORK }}</p>
              <p><strong>IP WIFI:</strong> {{ networkInfo.IP_WLAN }}</p>
              <p><strong>MÁSCARA WIFI:</strong> {{ networkInfo.MASK_WLAN }}</p>
              <p><strong>IP ETHERNET:</strong> {{ networkInfo.IP_ETH }}</p>
              <p>
                <strong>MÁSCARA ETHERNET:</strong> {{ networkInfo.MASK_ETH }}
              </p>
              <p><strong>GATEWAY:</strong> {{ networkInfo.GTW }}</p>
            </div>
            <div v-else>
              <b-form novalidate v-if="formType == 'wifi'">
                <small class="mb-2 d-block">
                  Atenção: o nome da rede (SSID) e a senha devem ser exatamente
                  iguais aos configurados no roteador para garantir a
                  conexão.</small
                >
                <b-form-text id="networkInputLiveHelp">
                  <label for="configNetworkInput">Rede *</label>
                </b-form-text>
                <b-form-input
                  v-model.trim="connect.NETWORK"
                  placeholder="Rede"
                  aria-describedby="networkInputLiveHelp networkInputLiveFeedback"
                  :state="networkState"
                  id="configNetworkInput"
                />

                <b-form-invalid-feedback
                  v-if="!networkState"
                  id="networkInputLiveFeedback"
                >
                  Campo de rede inválido
                </b-form-invalid-feedback>
                <p></p>
                <b-form-input
                  v-model="connect.PSW"
                  placeholder="Senha"
                  :type="showPwd ? 'text' : 'password'"
                  :state="pswState"
                >
                </b-form-input>
                <eye-icon
                  @click.native="showPwd = !showPwd"
                  v-if="!showPwd"
                  class="action-icon-right"
                  title=""
                />
                <eye-off-icon
                  @click.native="showPwd = !showPwd"
                  v-else
                  class="action-icon-right"
                  title=""
                />
                <b-form-invalid-feedback
                  v-if="!pswState"
                  id="networkInputLiveFeedback"
                >
                  A senha deve conter no mínimo 8 caracteres.
                </b-form-invalid-feedback>
              </b-form>
              <b-form novalidade v-else-if="formType == 'staticip'">
                Ao submeter esta configuração,
                <strong>o CIR reiniciará</strong>.
                <b-form-radio-group v-model="ethernet.type" class="center-xs">
                  <b-form-radio value="dhcp">DHCP</b-form-radio>
                  <b-form-radio value="static">IP fixo</b-form-radio>
                </b-form-radio-group>
                <div v-if="ethernet.type == 'static'" class="ip-form">
                  <b-form-text>IP ethernet</b-form-text>
                  <b-input-group>
                    <b-form-input
                      ref="ip0"
                      v-model="ethernet.STATIC_IP[0]"
                      :formatter="(value) => justNaturalNumbers(value, 0)"
                      list="toip"
                    />
                    <b-form-input
                      ref="ip1"
                      v-model="ethernet.STATIC_IP[1]"
                      :formatter="(value) => justNaturalNumbers(value, 1)"
                      list="toip"
                    />
                    <b-form-input
                      ref="ip2"
                      v-model="ethernet.STATIC_IP[2]"
                      :formatter="(value) => justNaturalNumbers(value, 2)"
                      list="toip"
                    />
                    <b-form-input
                      ref="ip3"
                      v-model="ethernet.STATIC_IP[3]"
                      :formatter="(value) => justNaturalNumbers(value, 3)"
                      list="toip"
                    />
                  </b-input-group>
                  <b-form-text>Máscara de rede</b-form-text>
                  <b-input-group>
                    <b-form-input
                      ref="mask0"
                      v-model="ethernet.MASK[0]"
                      :formatter="(value) => justNaturalNumbers(value, 0)"
                      list="toip"
                    />
                    <b-form-input
                      ref="mask1"
                      v-model="ethernet.MASK[1]"
                      :formatter="(value) => justNaturalNumbers(value, 1)"
                      list="toip"
                    />
                    <b-form-input
                      ref="mask2"
                      v-model="ethernet.MASK[2]"
                      :formatter="(value) => justNaturalNumbers(value, 2)"
                      list="toip"
                    />
                    <b-form-input
                      ref="mask3"
                      v-model="ethernet.MASK[3]"
                      :formatter="(value) => justNaturalNumbers(value, 3)"
                      list="toip"
                    />
                  </b-input-group>
                  <b-form-text>Gateway</b-form-text>
                  <b-input-group>
                    <b-form-input
                      ref="gateway0"
                      v-model="ethernet.GATEWAY[0]"
                      :formatter="(value) => justNaturalNumbers(value, 0)"
                      list="toip"
                    />
                    <b-form-input
                      ref="gateway1"
                      v-model="ethernet.GATEWAY[1]"
                      :formatter="(value) => justNaturalNumbers(value, 1)"
                      list="toip"
                    />
                    <b-form-input
                      ref="gateway2"
                      v-model="ethernet.GATEWAY[2]"
                      :formatter="(value) => justNaturalNumbers(value, 2)"
                      list="toip"
                    />
                    <b-form-input
                      ref="gateway3"
                      v-model="ethernet.GATEWAY[3]"
                      :formatter="(value) => justNaturalNumbers(value, 3)"
                      list="toip"
                    />
                  </b-input-group>
                  <b-form-text>DNS1</b-form-text>
                  <b-input-group>
                    <b-form-input
                      ref="dns10"
                      v-model="ethernet.DNS1[0]"
                      :formatter="(value) => justNaturalNumbers(value, 0)"
                      list="toip"
                    />
                    <b-form-input
                      ref="dns11"
                      v-model="ethernet.DNS1[1]"
                      :formatter="(value) => justNaturalNumbers(value, 1)"
                      list="toip"
                    />
                    <b-form-input
                      ref="dns12"
                      v-model="ethernet.DNS1[2]"
                      :formatter="(value) => justNaturalNumbers(value, 2)"
                      list="toip"
                    />
                    <b-form-input
                      ref="dns13"
                      v-model="ethernet.DNS1[3]"
                      :formatter="(value) => justNaturalNumbers(value, 3)"
                      list="toip"
                    />
                  </b-input-group>
                  <div v-if="addDNS2">
                    <b-form-text>DNS 2 (opcional)</b-form-text>
                    <b-input-group>
                      <b-form-input
                        ref="dns20"
                        v-model="ethernet.DNS2[0]"
                        :formatter="(value) => justNaturalNumbers(value, 0)"
                        list="toip"
                      />
                      <b-form-input
                        ref="dns21"
                        v-model="ethernet.DNS2[1]"
                        :formatter="(value) => justNaturalNumbers(value, 1)"
                        list="toip"
                      />
                      <b-form-input
                        ref="dns22"
                        v-model="ethernet.DNS2[2]"
                        :formatter="(value) => justNaturalNumbers(value, 2)"
                        list="toip"
                      />
                      <b-form-input
                        ref="dns23"
                        v-model="ethernet.DNS2[3]"
                        :formatter="(value) => justNaturalNumbers(value, 3)"
                        list="toip"
                      />
                    </b-input-group>
                  </div>
                  <div v-else>
                    <br />
                    <b-link @click="addDNS2 = true">Adicionar DNS 2?</b-link>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
          <footer slot="footer" class="row around-xs">
            <b-btn
              variant="3v3"
              size="sm"
              v-if="!connectionConfigForm"
              @click="showConnectWifiForm()"
              ><wifi-icon title="" />
            </b-btn>
            <b-btn
              variant="3v3"
              size="sm"
              v-if="!connectionConfigForm"
              @click="showStaticIpConfig()"
              ><ethernet-icon title="" />
            </b-btn>
            <b-btn
              variant="red"
              size="sm"
              v-if="connectionConfigForm"
              @click="
                connectionConfigForm = false;
                formType = '';
              "
              ><close-icon title="" />
            </b-btn>
            <b-btn
              variant="3v3"
              size="sm"
              v-if="connectionConfigForm"
              @click="saveConfiguration()"
              ><save-icon title="" />
            </b-btn>
          </footer>
        </b-card>
        <b-card
          bg-variant="white"
          header-bg-variant="light"
          footer-bg-variant="light"
          align="center"
          header-text-variant="black"
        >
          <header slot="header">
            <h4>{{ !rfForm ? "Rádio" : "Editar RF" }}</h4>
          </header>
          <div class="card-text start-xs">
            <div v-if="!rfForm">
              <p><strong>CANAL:</strong> {{ rfInfo.CHANNEL }}</p>
              <p><strong>TIMEOUT:</strong> {{ rfInfo.TOUT }}</p>
              <p><strong>TENTATIVAS:</strong> {{ rfInfo.RETRY }}</p>
            </div>
            <div v-else>
              <b-form novalidate @keyup.enter="submitRFConfig">
                <b-form-text id="channelInputLiveHelp"> Canal * </b-form-text>
                <b-form-input
                  v-model="rfEdit.CHANNEL"
                  placeholder="Canal"
                  aria-describedby="channelInputLiveHelp channelInputLiveFeedback"
                  type="number"
                  :state="channelState"
                  :min="0"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!channelState"
                  id="channelInputLiveFeedback"
                >
                  Campo inválido.
                </b-form-invalid-feedback>
                <b-form-text id="toutInputLiveHelp"> Time out * </b-form-text>
                <b-form-input
                  v-model="rfEdit.TOUT"
                  placeholder="Time out"
                  aria-describedby="toutInputLiveHelp toutInputLiveFeedback"
                  type="number"
                  :state="toutState"
                  :min="0"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!toutState"
                  id="toutInputLiveFeedback"
                >
                  Campo inválido.
                </b-form-invalid-feedback>
                <b-form-text id="retryInputLiveHelp">
                  Tentativas *
                </b-form-text>
                <b-form-input
                  v-model="rfEdit.RETRY"
                  placeholder="Tentativas"
                  aria-describedby="retryInputLiveHelp retryInputLiveFeedback"
                  type="number"
                  :state="retryState"
                  :min="0"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!retryState"
                  id="retryInputLiveFeedback"
                >
                  Campo inválido.
                </b-form-invalid-feedback>
              </b-form>
            </div>
          </div>
          <footer slot="footer" class="row around-xs">
            <b-btn
              variant="3v3"
              size="sm"
              v-if="!rfForm"
              @click="showRfConfigForm()"
              ><pencil-icon title=""
            /></b-btn>
            <b-btn variant="red" size="sm" v-if="rfForm" @click="rfForm = false"
              ><close-icon title=""
            /></b-btn>
            <b-btn
              variant="3v3"
              size="sm"
              v-if="rfForm"
              @click="submitRFConfig()"
              ><save-icon title=""
            /></b-btn>
          </footer>
        </b-card>

        <b-card
          bg-variant="white"
          header-bg-variant="light"
          footer-bg-variant="light"
          align="center"
          header-text-variant="black"
        >
          <header slot="header">
            <h4>{{ !APIForm ? "Chave de API" : "Editar Chave de API" }}</h4>
          </header>
          <div class="card-text start-xs">
            <div v-if="!APIForm">
              <p><strong>CHAVE:</strong> {{ APIInfo.KEY }}</p>
              <p>
                <strong>STATUS:</strong>
                {{ APIInfo.ENABLED === 1 ? "Habilitada" : "Desabilitada" }}
              </p>
              <p><strong>TIPO:</strong> {{ APIInfo.TYPE }}</p>
            </div>
            <div v-else>
              <b-form novalidate @keyup.enter="submitAPIConfig">
                <b-form-text id="channelInputLiveHelp">
                  Digite a nova chave
                </b-form-text>
                <b-form-input
                  v-model="APIEdit.KEY"
                  placeholder="Chave"
                  aria-describedby="channelInputLiveHelp channelInputLiveFeedback"
                  type="text"
                  :state="keyState"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!keyState"
                  id="channelInputLiveFeedback"
                >
                  A nova chave deve possuir ao menos 8 caracteres
                </b-form-invalid-feedback>
                <b-form-text id="toutInputLiveHelp">
                  Deseja habilitar a nova chave?
                </b-form-text>
                <b-form-checkbox
                  v-model="APIEdit.ENABLED"
                  value="true"
                  unchecked-value="false"
                >
                  Habilitar nova chave
                </b-form-checkbox>
                <b-form-text>
                  Ao confirmar as alterações da chave, o
                  <strong>
                    CIR será reiniciado e os atuais usuários serão deslogados do
                    sistemas.
                  </strong>
                </b-form-text>
              </b-form>
            </div>
          </div>
          <footer slot="footer" class="row around-xs">
            <b-btn
              variant="3v3"
              size="sm"
              v-if="!APIForm"
              @click="showAPIConfigForm()"
              ><pencil-icon title=""
            /></b-btn>
            <b-btn
              variant="red"
              size="sm"
              v-if="APIForm"
              @click="APIForm = false"
              ><close-icon title=""
            /></b-btn>
            <b-btn
              variant="3v3"
              size="sm"
              v-if="APIForm"
              @click="submitAPIConfig()"
              ><save-icon title=""
            /></b-btn>
          </footer>
        </b-card>

        <!-- MANEJO -->
        <!-- <b-card bg-variant="white" header-bg-variant="light" footer-bg-variant="light" align="center"
                  header-text-variant="black">
                  <header slot='header'>
                    <h4>{{ !ManagementAPIForm ? 'Acesso a api de manejo' : 'Editar Chave de API de manejo'}}</h4>
                  </header>
                  <div class='card-text start-xs'>
                    <div v-if='!ManagementAPIForm'>
                      <p><strong>CHAVE:</strong> {{ ManagementAPIForm.KEY}}</p>
                      <p><strong>STATUS:</strong> {{ ManagementAPIForm.ENABLED === 1 ? "Habilitada" : "Desabilitada"}}</p>
                      <p><strong>TIPO:</strong> {{ ManagementAPIForm.TYPE}}</p>
                    </div>
                    <div v-else>
                      <b-form novalidate @keyup.enter='submitAPIConfig'>
                        <b-form-text id='channelInputLiveHelp'>
                          Digite a nova chave
                        </b-form-text>
                        <b-form-input v-model='ManagementAPIForm.KEY' placeholder='Chave'
                          aria-describedby='channelInputLiveHelp channelInputLiveFeedback' type='text' :state='managementkeyState'>
                        </b-form-input>
                        <b-form-invalid-feedback v-if='!managementkeyState' id='channelInputLiveFeedback'>
                          A nova chave deve possuir ao menos 8 caracteres
                        </b-form-invalid-feedback>
                        <b-form-text id='toutInputLiveHelp'>
                          Deseja habilitar a nova chave?
                        </b-form-text>
                        <b-form-checkbox v-model='ManagementAPIForm.ENABLED' value='true' unchecked-value='false'> Habilitar nova chave
                        </b-form-checkbox>
                        <b-form-text>
                          Ao confirmar as alterações da chave, o <strong> CIR será reiniciado e os atuais usuários serão deslogados do
                            sistemas. </strong>
                        </b-form-text>
                      </b-form>
                    </div>
                  </div>
                  <footer slot='footer' class='row around-xs'>
                    <b-btn variant='3v3' size='sm' v-if='!ManagementAPIForm' @click='showManagementAccessAPIConfig()'>
                      <pencil-icon title='' />
                    </b-btn>
                    <b-btn variant='red' size='sm' v-if='ManagementAPIForm' @click='ManagementAPIForm = false'>
                      <close-icon title='' />
                    </b-btn>
                    <b-btn variant='3v3' size='sm' v-if='ManagementAPIForm' @click='submitManagementAPIConfig()'>
                      <save-icon title='' />
                    </b-btn>
                  </footer>
                </b-card> -->
      </b-card-group>
    </div>
    <b-modal
      centered
      ref="confirmWifi"
      no-close-on-backdrop
      hide-header
      @ok="submitConnection"
      ok-title="Salvar"
      cancel-title="Cancelar"
      ok-variant="3v3"
      cancel-variant="outline-secondary"
    >
      <h5 class="fw-bold">Confirmação</h5>
      <p class="mt-3 mb-2">
        Tem certeza que quer salvar os dados de Wi-Fi inseridos?
      </p>
      <small class="text-muted"
        >Em caso de erro, a conexão pode ser perdida.</small
      >
    </b-modal>
  </div>
</template>

<script>
import { network, cmd } from "@/api";

export default {
  name: "network",
  props: {
    mobile: Boolean,
  },
  created() {
    network
      .networkInfo()
      .then((ret) => {
        this.networkInfo = ret;
        return network.rfInfo();
      })
      .then((ret) => {
        this.rfInfo = ret;
      })
      .then((ret) => {
        return network.apiInfo();
      })
      .then((ret) => {
        if (ret.length) {
          this.APIInfo = ret[0];
        }
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      selected: null,
      showPwd: false,
      connectionConfigForm: false,
      rfForm: false,
      connect: {
        NETWORK: null,
        PSW: null,
      },
      rfEdit: {
        CHANNEL: null,
        TOUT: null,
        RETRY: null,
      },
      ethernet: {
        type: "dhcp",
        STATIC_IP: [0, 0, 0, 0],
        MASK: [0, 0, 0, 0],
        GATEWAY: [0, 0, 0, 0],
        DNS1: [0, 0, 0, 0],
        DNS2: [0, 0, 0, 0],
      },
      addDNS2: false,
      formType: "",
      wifiOptions: [],
      networkInfo: {
        IP_ETH: "-",
        MASK_ETH: "-",
        IP_WLAN: "-",
        MASK_WLAN: "-",
        GTW: "-\n",
        NETWORK: "-\n",
      },
      rfInfo: {
        ID: null,
        UPDATE: "-",
        CHANNEL: null,
        TOUT: null,
        RETRY: null,
      },
      APIInfo: {
        KEY: null,
        ENABLED: false,
        TYPE: null,
      },
      ManagementAPIInfo: {
        KEY: null,
        ENABLED: false,
        TYPE: null,
      },
      APIForm: false,
      ManagementAPIForm: false,
      APIEdit: {
        KEY: null,
        ENABLED: false,
        TYPE: null,
      },
      ManagementAPIEdit: {
        KEY: null,
        ENABLED: false,
        TYPE: null,
      },
    };
  },
  computed: {
    cardHeaderTitle() {
      if (!this.connectionConfigForm) {
        return "Redes";
      }

      if (this.formType === "wifi") {
        return "WIFI";
      }
      return "Ethernet";
    },
    computedClass() {
      if (this.mobile) {
        return "mobile-header pt-5";
      }
      return "desktop-header mt-4";
    },
    computedClassHeader() {
      if (this.mobile) {
        return "page-title config-title-mobile col-xs-12  mt-0";
      }
      return "page-title config-title col-xs-12  mt-0";
    },
    networkState() {
      return this.connect.NETWORK !== "" && this.connect.NETWORK !== null;
    },
    pswState() {
      return this.connect.PSW == "" || this.connect.PSW.length >= 8;
    },
    channelState() {
      return this.rfEdit.CHANNEL !== "" && this.rfEdit.CHANNEL >= 0;
    },
    toutState() {
      return this.rfEdit.TOUT !== "" && this.rfEdit.TOUT >= 0;
    },
    retryState() {
      return this.rfEdit.RETRY !== "" && this.rfEdit.RETRY >= 0;
    },
    managementkeyState() {
      return (
        this.ManagementAPIEdit.KEY !== "" &&
        this.ManagementAPIEdit.KEY !== null &&
        this.ManagementAPIEdit.KEY.length >= 8
      );
    },
    keyState() {
      return (
        this.APIEdit.KEY !== "" &&
        this.APIEdit.KEY !== null &&
        this.APIEdit.KEY.length >= 8
      );
    },
    enabledState() {
      return this.APIEdit.ENABLED !== "";
    },
  },
  methods: {
    saveConfiguration() {
      if (this.formType == "staticip") {
        return this.submitConnection();
      }

      this.openWifiConfirmation();
    },
    openWifiConfirmation() {
      debugger;
      if (this.formType == "wifi" && this.networkState && this.pswState)
        this.$refs.confirmWifi.show();
    },
    justNaturalNumbers(value, input) {
      if (!value || isNaN(value) || value < 0) return 0;
      else if (value > 255) return 255;
      else return Math.floor(value);
    },
    showWaitDialog() {
      wait.show();
    },
    hideWaitDialog() {
      wait.hide();
    },
    resetForm(type) {
      if (type == "wifi") {
        if (this.networkInfo.NETWORK) {
          this.selected = this.networkInfo.NETWORK;
          this.connect.NETWORK = this.networkInfo.NETWORK;
        }
        this.connect.PSW = "";
      } else if (type == "rf") {
        this.rfEdit.CHANNEL =
          this.rfInfo.CHANNEL >= 0 ? this.rfInfo.CHANNEL : "";
        this.rfEdit.TOUT = this.rfInfo.TOUT >= 0 ? this.rfInfo.TOUT : "";
        this.rfEdit.RETRY = this.rfInfo.RETRY >= 0 ? this.rfInfo.RETRY : "";
      } else if (type === "api") {
        this.APIEdit.KEY = this.APIInfo.KEY !== "" ? this.APIInfo.KEY : "";
        this.APIEdit.ENABLED = this.APIInfo.ENABLED
          ? this.APIInfo.ENABLED
          : false;
      } else if (type === "managementApi") {
        this.ManagementAPIEdit.KEY =
          this.ManagementAPIInfo.KEY !== "" ? this.ManagementAPIInfo.KEY : "";
        this.ManagementAPIEdit.ENABLED = this.ManagementAPIInfo.ENABLED
          ? this.ManagementAPIInfo.ENABLED
          : false;
      }
    },
    changeNetworkField(value) {
      this.connect.NETWORK = value;
    },
    showConnectWifiForm() {
      this.resetForm("wifi");
      wait.show();
      this.selected = this.networkInfo.NETWORK;
      network
        .wifiOptions()
        .then((ret) => {
          this.wifiOptions = ret;
        })
        .catch((err) => {
          console.log(err);
        })
        .then((_) => {
          wait.hide();
          this.formType = "wifi";
          this.connectionConfigForm = true;
        });
    },
    showStaticIpConfig() {
      this.addDNS2 = false;
      this.formType = "staticip";
      this.connectionConfigForm = true;
    },
    teste() {
      console.log("testando");
    },
    submitConnection(evt) {
      if (this.formType == "wifi" && this.networkState && this.pswState) {
        let data = {
          NETWORK: this.connect.NETWORK,
          PSW: this.connect.PSW,
        };
        wait.show();
        network
          .updateWifi(data)
          .then((ret) => {
            if (ret.status) window.reload();
            else alert(ret.log);
          })
          .catch((err) => {
            alert("Ocorreu um erro na edição de WIFI.");
            window.reload();
          });
      } else if (this.formType == "staticip") {
        if (!this.addDNS2) this.ethernet.DNS2 = null;
        network
          .updateStaticIp(this.ethernet)
          .catch((err) => {
            console.log(err);
          })
          .then((ret) => {
            this.addDNS2 = false;
            this.formType = "";
            this.connectionConfigForm = false;
          });
      }
    },
    showRfConfigForm() {
      this.resetForm("rf");
      this.rfForm = true;
    },
    showAPIConfigForm() {
      this.resetForm("api");
      this.APIForm = true;
    },
    showManagementAccessAPIConfig() {
      this.resetForm("managementApi");
      this.ManagementAPIForm = true;
    },
    submitRFConfig(evt) {
      if (this.channelState && this.toutState && this.retryState) {
        let data = {
          ID: this.rfInfo.ID,
          CHANNEL: this.rfEdit.CHANNEL,
          TOUT: this.rfEdit.TOUT,
          RETRY: this.rfEdit.RETRY,
        };
        this.rfForm = false;
        network
          .updateRF(data)
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.status) return network.rfInfo();
          })
          .then((att) => {
            if (att) this.rfInfo = att;
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro na edição de RF.");
          });
      }
    },
    submitAPIConfig(evt) {
      let data = {
        KEY: this.APIEdit.KEY,
        ENABLED: this.APIEdit.ENABLED === "true" ? true : false,
        TYPE: "Bearer token",
      };
      this.APIForm = false;
      network
        .updateAPI(data)
        .then((ret) => {
          if (ret.status) return network.apiInfo();
        })
        .then((att) => {
          if (att) this.APIInfo = att[0];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro na edição da Chave de API.");
        })
        .finally((ret) => cmd.exec({ CMD: "pm2 restart all" }));
    },
    submitManagementAPIConfig() {
      let data = {
        KEY: this.ManagementAPIEdit.KEY,
        ENABLED: this.ManagementAPIEdit.ENABLED === "true" ? true : false,
        TYPE: "Bearer token",
      };
      this.APIForm = false;

      network
        .updateManagementAPIKey(data)
        .then((ret) => {
          if (ret.status) return network.managementApiKeyInfo();
        })
        .then((att) => {
          if (att) this.APIInfo = att[0];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro na edição da Chave de API.");
        });
      // .finally(ret => cmd.exec({ CMD: "pm2 restart server" }));
    },
  },
};
</script>

<style scoped>
.ip-form .form-text {
  margin-top: 10px;
}
.ip-form input {
  text-align: center !important;
}
.card-text > div > p {
  color: var(--text-gray-primary);
}
.config-title-mobile {
  top: 36px;
}
.config-title {
  max-height: 1.1em;
  padding: 0 0 4px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@media screen and (max-width: 767px) {
  .card-text {
    font-size: 0.88em;
  }
}
</style>
